<div class="modal-body">
  <div class="p-2 text-center">
    <h4 class="mb-4">{{ loadingText | messageTranslate }}</h4>
    <ngb-progressbar type="info" [striped]="stripped || progressPending" [value]="getProgressPercent" [animated]="true"/>
    @if (allowCancel) {
      <button type="button" class="btn btn-sm btn-link mt-4" (click)="onCancel()">{{ cancelText | messageTranslate }}</button>
    }
  </div>
</div>
